import { render, staticRenderFns } from "./ModalCadastroFuncionario.vue?vue&type=template&id=8ae5c026"
import script from "./ModalCadastroFuncionario.vue?vue&type=script&lang=js"
export * from "./ModalCadastroFuncionario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports